<template lang="pug">
  .category
    el-row(
      v-for="item, index in data"
      :key="index"
    )
      el-col(v-if="index === 0" :span="4") {{ $t('项目类别') }}
      el-col(:span="20" :offset="index === 0 ? 0 : 4")
        span(style="margin-right: 20px") {{ getCategoryName(item) }}
        span(v-if="item.children && item.children.length !== 0") 【{{ $t('Scope') }}:
          span {{ item.children && item.children.map(i => getScopeName(i)).join(', ') }}】
</template>

<script>
import db from '@/umcc/db'

export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    }
  },
  methods: {
    getScopeName (item) {
      // if (this.isZh) return item.scope_name_ch + '(' + item.scope_name + ')'
      return item.scope_name
    },
    getCategoryName (item) {
      // if (this.isZh) return item.category_name_ch + '(' + item.category_name + ')'
      return item.category_name
    }
  }
}
</script>
